import TimerPickerComponent from "components/Shared/TimerPickerComponent"
import React, { useEffect, useState } from "react"
import { InputGroup, Table } from "reactstrap"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import Switch from "components/Shared/Switch"

const StoreTimes = ({
  isSeprateTime,
  timeType,
  timesOptions,
  setTimesOptions,
  open_24_hours,
  t,
}) => {
  const [selectedTimeOptions, setSelectedTimeOptions] = useState([])
  const [closedDays, setClosedDays] = useState()

  useEffect(() => {
    const closedDays = timesOptions?.map(hour => hour.closed)
    setClosedDays(closedDays)
  }, [timesOptions])

  useEffect(() => {
    const newTime = isSeprateTime
      ? timeType === "delivery"
        ? timesOptions.delivery
        : timesOptions.pickup
      : timesOptions
    setSelectedTimeOptions(newTime || []) // Use a default empty array if timesOptions is undefined
  }, [isSeprateTime, timesOptions])

  const handleTimeChange = (dayOfWeek, time, type) => {
    // Convert the selected time to a formatted string
    const formattedTime = time.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit",
    })

    // Update the selectedTimes state with the formatted time for the specified type (open or close)
    if (isSeprateTime) {
      if (timeType === "delivery") {
        setTimesOptions(prevState => ({
          ...prevState,
          delivery: prevState.delivery.map(item =>
            item.dayOfWeek === dayOfWeek
              ? {
                  ...item,
                  [type === "open" ? "openingTime" : "closingTime"]:
                    formattedTime,
                }
              : item
          ),
        }))
      } else if (timeType === "pickup") {
        setTimesOptions(prevState => ({
          ...prevState,
          pickup: prevState.pickup.map(item =>
            item.dayOfWeek === dayOfWeek
              ? {
                  ...item,
                  [type === "open" ? "openingTime" : "closingTime"]:
                    formattedTime,
                }
              : item
          ),
        }))
      }
    } else {
      setTimesOptions(prevState => {
        return prevState.map(prevTime => {
          if (prevTime.dayOfWeek === dayOfWeek) {
            // Update the time for the specific day and type (open or close)
            if (type === "open") {
              return { ...prevTime, openingTime: formattedTime }
            } else if (type === "close") {
              return { ...prevTime, closingTime: formattedTime }
            }
          }
          return prevTime
        })
      })
    }
  }

  return (
    <div>
      <Table striped bordered hover className="mt-2">
        <thead>
          <tr>
            <th>{t("Day Of Week")}</th>
            <th>{t("Opening Time")}</th>
            <th>{t("Closing Time")}</th>
          </tr>
        </thead>
        <tbody>
          {selectedTimeOptions.length &&
            selectedTimeOptions?.map((item, index) => (
              <tr key={index}>
                <td>
                  <div className="d-flex align-items-center mt-1">
                    <Switch
                      onClickHandler={e => {
                        const updatedClosedDays = [...closedDays]
                        updatedClosedDays[index] = !updatedClosedDays[index]
                        setClosedDays(updatedClosedDays)

                        const updatedTimesOptions = timesOptions.map(
                          (item, i) =>
                            i === index
                              ? { ...item, closed: updatedClosedDays[index] }
                              : item
                        )
                        setTimesOptions(updatedTimesOptions)
                      }}
                      isChecked={!closedDays[index]}
                      disabled={open_24_hours}
                    />
                    <span className="ms-2"> {t(item.dayOfWeek)}</span>
                  </div>
                </td>

                {!closedDays[index] && (
                  <td>
                    <InputGroup>
                      <Flatpickr
                        className="form-control d-block"
                        value={item.openingTime}
                        placeholder="Select time"
                        options={{
                          enableTime: true,
                          noCalendar: true,
                          dateFormat: "H:i",
                        }}
                        onChange={selectedDates => {
                          const updatedTimesOptions = [...timesOptions]
                          const updatedItem = { ...item }
                          updatedItem.openingTime = selectedDates[0]
                            ? selectedDates[0].toTimeString().slice(0, 5)
                            : ""
                          updatedTimesOptions[index] = updatedItem
                          setTimesOptions(updatedTimesOptions)
                        }}
                        disabled={open_24_hours}
                      />

                      <div className="input-group-append">
                        <span className="input-group-text h-100">
                          <i className="mdi mdi-clock-outline" />
                        </span>
                      </div>
                    </InputGroup>
                  </td>
                )}
                {!closedDays[index] && (
                  <td>
                    <InputGroup>
                      <Flatpickr
                        className="form-control d-block"
                        value={item.closingTime}
                        placeholder="Select time"
                        options={{
                          enableTime: true,
                          noCalendar: true,
                          dateFormat: "H:i",
                        }}
                        onChange={selectedDates => {
                          const updatedTimesOptions = [...timesOptions]
                          const updatedItem = { ...item }
                          updatedItem.closingTime = selectedDates[0]
                            ? selectedDates[0].toTimeString().slice(0, 5)
                            : ""
                          updatedTimesOptions[index] = updatedItem
                          setTimesOptions(updatedTimesOptions)
                        }}
                        disabled={open_24_hours}
                      />

                      <div className="input-group-append">
                        <span className="input-group-text h-100">
                          <i className="mdi mdi-clock-outline" />
                        </span>
                      </div>
                    </InputGroup>
                  </td>
                )}

                {closedDays[index] && (
                  <td colSpan={2}>
                    <p className="text-center pt-1">{t("Closed")}</p>
                  </td>
                )}
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  )
}

export default StoreTimes
